import type { CustomFlowbiteTheme } from 'flowbite-react';

export const carouselTheme: CustomFlowbiteTheme['carousel'] = {
  root: {
    base: 'relative h-full w-full',
    leftControl:
      'absolute left-0 top-1/2 flex h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full bg-black focus:outline-none',
    rightControl:
      'absolute right-0 top-1/2 flex h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full bg-black focus:outline-none',
  },
  indicators: {
    active: {
      off: 'bg-titan-night-900/50 hover:bg-titan-night-900',
      on: 'bg-titan-folly',
    },
    base: 'bg-titan-night-900 h-3 w-3 rounded-full',
    wrapper: 'absolute bottom-0 left-1/2 flex -translate-x-1/2 space-x-3',
  },
  item: {
    base: 'absolute left-1/2 top-1/2 block w-full -translate-x-1/2 -translate-y-1/2',
    wrapper: {
      off: 'w-full shrink-0 transform cursor-default snap-center',
      on: 'w-full shrink-0 transform cursor-grab snap-center',
    },
  },
  control: {
    base: 'inline-flex h-8 w-8 items-center justify-center',
    icon: 'text-titan-night h-5 w-5',
  },
  scrollContainer: {
    base: 'flex h-full snap-mandatory overflow-y-hidden overflow-x-scroll scroll-smooth rounded-lg',
    snap: 'snap-x',
  },
};
